import { useAppSelector } from "../app/hooks";
import { selectIsAuthenticated } from "../features/auth/AuthSlice";
import MissingRoute from "./MissingRoute";

interface Props {
  component: React.ComponentType | any;
  path?: string;
}

const AuthCheckRoute: React.FC<Props> = ({ component: RouteComponent }) => {
  const isAuthenticated = useAppSelector(selectIsAuthenticated);

  return !isAuthenticated ? <RouteComponent /> : <MissingRoute />;
};

export default AuthCheckRoute;
